<template>
  <div>
    <div class="box">
      <ul style="min-height: 400px">
        <li v-for="(item, index) in lists" :key="'l' + index">
          <router-link
            :to="{
              path: '/detail',
              query: {
                newstype: item.newstype,
                id: item.id,
              },
            }"
          >
            <p v-html="item.title" class="news-title"></p>
            <span>{{ item.addtime }}</span>
          </router-link>
        </li>
      </ul>
      <div class="fenye man-top20">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          @current-change="handleCurrentChange"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import { formatNewsListDate } from '@/utils/formatter'
import request from '@/utils/request'
export default {
  name: 'list',
  data() {
    return {
      url: '',
      param: {
        start: 0,
        limit: 10
      },
      total: 0,
      page: 1,
      pageSize: 10,
      lists: []
    }
  },
  created() {
    // this.initList()
    // console.log("created")
  },
  watch: {
    page() {
      this.initList()
      // console.log("page")
    },
    $route: {
      handler: function (route) {
        this.initList()
      },
      immediate: true
    }
  },
  methods: {
    initList() {
      let that = this
      // console.log(this.$route.query.newstype)
      let newstype = this.$route.query.newstype
      if (newstype === 'szdt') {
        that.url = '/news/szdt/list'
      } else if (newstype === 'jycy') {
        that.url = '/news/jycy/list'
      } else {
        that.url = '/news/xwgg/list'
        newstype = 'xwgg'
      }
      that.param = {
        start: (that.page - 1) * that.pageSize,
        limit: that.pageSize
      }

      // if (
      //   !this.$route.query.newstype ||
      //   this.$route.query.newstype === 'notice'
      // ) {
      //   that.url = '/notice/list'
      //   that.param = { page: that.page, rows: that.pageSize }
      //   if (this.$route.query.category && this.$route.query.category === 'sz') {
      //     that.param = { page: that.page, rows: that.pageSize, category: 'sz' }
      //   }
      // } else {
      //   that.url = '/news/list'
      //   that.param = {
      //     category: parseInt(this.$route.query.nav),
      //     page: that.page,
      //     rows: that.pageSize,
      //   }
      // }
      request.post(that.url, that.param).then((response) => {
        if (response.data.code === 200) {
          let list = response.data.data.list
          that.total = response.data.data.total
          list.forEach((elem) => {
            Object.assign(elem, {
              newstype: newstype
            })
          })
          // console.log(list)
          that.lists = list
        }
      })
    },
    handleCurrentChange(e) {
      this.page = e
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('../../styles/main.scss');
</style>
<style lang="scss">
.news-title {
  span {
    color: inherit !important;
    float: left !important;
  }
}
.el-menu {
  border-right: none;
}

.el-pagination {
  span,
  button {
    height: 28px !important;
    line-height: 28px !important;
  }
}

.el-pager {
  li {
    height: 28px !important;
    line-height: 28px !important;
    border-bottom: none !important;
    width: 28px !important;
    margin: 0 5px;
    background: #f4f4f5 !important;
  }

  li:hover {
    border-bottom: none !important;
    background: none !important;
  }
}

.wenZhang {
  min-height: 300px;
}

.bottom-btn-area {
  position: absolute !important;
  height: 60px !important;
  width: inherit !important;
  bottom: 0;
}

.bottom-btn-area {
  height: inherit !important;
  width: inherit !important;
}

.content {
  display: block;
  position: relative;
  height: auto !important;
  margin: auto auto 80px auto !important;
  width: 100% !important;

  p {
    line-height: 2rem;
    text-indent: 0;
    color: #000;
  }

  a {
    line-height: 2rem;
    text-indent: 0;
    color: #0000ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/list/list.vue